/**
 *
 * @param {string} url - The URL to check.
 * @description Checks if the given URL is a relative path.
 * A relative path starts with a forward slash ("/").
 * This function returns true if the URL is a relative path, and false otherwise.
 * @return {boolean}
 *
 * @example
 * // Input: "/some/path"
 * // Output: true
 * // Input: "#some/path"
 * // Output: false
 */
export default (url) => {
  return !!url && url.startsWith('/');
};
